import type { ReactNode, SVGProps } from "react";

export type CoreIconName =
  | "arrow"
  | "at"
  | "check"
  | "chevron"
  | "clock"
  | "close"
  | "database"
  | "download"
  | "file"
  | "folder"
  | "history"
  | "link"
  | "list"
  | "mic"
  | "paperclip"
  | "search"
  | "sparkle"
  | "upload"
  | "warning"
  | "x";

const paths: Record<CoreIconName, ReactNode> = {
  arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
  at: <><circle cx="12" cy="12" r="8" /><path d="M16 12v1.5a2 2 0 0 1-4 0V10a2.5 2.5 0 1 1 4 0v2Zm0 0c0 2.2 3.5 2.2 3.5-.4" /></>,
  check: <path d="m4 12 5 5L20 6" />,
  chevron: <path d="m6 9 6 6 6-6" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  close: <path d="M18 6 6 18M6 6l12 12" />,
  database: <><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" /></>,
  download: <><path d="M12 3v12m-5-5 5 5 5-5M4 21h16" /></>,
  file: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6" /></>,
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />,
  history: <><path d="M4 5v5h5" /><path d="M5.5 9A8 8 0 1 1 4 14" /><path d="M12 8v5l3 2" /></>,
  link: <><path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.1 1.1" /><path d="M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.1-1.1" /></>,
  list: <><path d="M8 6h13M8 12h13M8 18h13" /><path d="M3 6h.01M3 12h.01M3 18h.01" /></>,
  mic: <><rect x="9" y="3" width="6" height="12" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></>,
  paperclip: <path d="m21 11-9 9a5 5 0 0 1-7-7l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-3-3l8.5-8.5" />,
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>,
  sparkle: <path d="m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9Z" />,
  upload: <><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /></>,
  warning: <><path d="M12 9v4M12 17h.01" /><path d="m10.3 3.9-8 14.1A2 2 0 0 0 4 21h16a2 2 0 0 0 1.7-3l-8-14.1a2 2 0 0 0-3.4 0Z" /></>,
  x: <path d="M18 6 6 18M6 6l12 12" />,
};

export function CoreIcon({
  name,
  size = 16,
  ...props
}: SVGProps<SVGSVGElement> & { name: CoreIconName; size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
